var map = {
	"./firma_template1.svg": 1578,
	"./firma_template2.svg": 1579,
	"./firma_template3.svg": 1580,
	"./firma_template4.svg": 1581,
	"./firma_template5.svg": 1582,
	"./firma_template6.svg": 1583,
	"./firma_template7.svg": 1584,
	"./firma_template8.svg": 1585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1577;